"use client";

import { c as _c } from "react/compiler-runtime";
import { Provider } from "react-redux";
import { makeStore } from "@/store/store";
const store = makeStore();
export default function StoreProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Provider store={store}>{children}</Provider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}